import { render, staticRenderFns } from "./BlackbookJockeyAndTrainer.vue?vue&type=template&id=6ac1dcc0&scoped=true&"
import script from "./BlackbookJockeyAndTrainer.vue?vue&type=script&lang=js&"
export * from "./BlackbookJockeyAndTrainer.vue?vue&type=script&lang=js&"
import style0 from "./BlackbookJockeyAndTrainer.vue?vue&type=style&index=0&id=6ac1dcc0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac1dcc0",
  null
  
)

export default component.exports